// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".radio-custom[data-v-11701e70] {\n  padding-top: 0.2rem;\n}", ""]);
// Exports
module.exports = exports;
